import {request} from "../../Base/HTTP";
import HttpMethod from "../../Constants/Base/HttpMethod";

export async function getProjectAccess(projectId) {
    return await request(`/api/project-access`, {projectId});
}

export async function updateProjectAccess(data) {
    return await request(`/api/project-access/${data.projectId}/${data.userId}`, data, HttpMethod.PUT);
}